import styled from 'styled-components';

const LiveDetailTabs = styled.div.attrs<{ 'data-admin-tabs'?: string }>({ 'data-admin-tabs': '' })`
  flex-shrink: 0;
  display: flex; flex-wrap: wrap; gap: var(--space-2); margin-bottom: var(--space-4);
  && button[role="tab"] { display: inline-flex; align-items: center; justify-content: center; min-height: var(--control-md);
    padding: var(--space-3) var(--space-4); border: 1px solid var(--color-border-default); border-radius: var(--radius-md);
    background: var(--color-bg-surface); color: var(--color-text-secondary); font-family: var(--font-family-base);
    font-size: var(--text-body); line-height: var(--leading-body); cursor: pointer; }
  && button[role="tab"][aria-selected="true"] { border-color: var(--color-text-link); background: var(--color-brand-subtle); color: var(--color-text-link); font-weight: 600; }
  && button[role="tab"]:hover:not(:disabled) { border-color: var(--color-text-link); background: var(--color-brand-subtle); color: var(--color-text-link); }
  button:disabled { cursor: wait; }
  button:focus-visible { outline: 2px solid var(--color-focus-ring); outline-offset: -2px; }
`;

export default LiveDetailTabs;
